import { render, staticRenderFns } from "./my-order-details.vue?vue&type=template&id=3db806a6&scoped=true"
import script from "./my-order-details.vue?vue&type=script&lang=js"
export * from "./my-order-details.vue?vue&type=script&lang=js"
import style0 from "./my-order-details.vue?vue&type=style&index=0&id=3db806a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db806a6",
  null
  
)

export default component.exports